/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Viewresources1Inputs */

const en_help_viewresources1 = /** @type {(inputs: Help_Viewresources1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Resources`)
};

/**
* | output |
* | --- |
* | "View Resources" |
*
* @param {Help_Viewresources1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_viewresources1 = /** @type {((inputs?: Help_Viewresources1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Viewresources1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_viewresources1(inputs)
});
export { help_viewresources1 as "help_viewResources" }